function hulkapps_custom_init() {
    $ = hulkapps_jQuery;
    const $formulaEle = $('.hulkapps_option.fm_render');
    $('#option_total').before('<div class="hulk-custom-calculation-div"></div');


    function monitorFormulaPrice() {
        const element = document.querySelector('input.product-form__variants[type="hidden"]');
        const config = { attributes: true };
        const callback = function (mutations, observer) {
            for (const mutation of mutations) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                    const thisEle = mutation.target;
                    triggerPriceChange(thisEle);
                }
            }
        }
        const observer = new MutationObserver(callback);
        observer.observe(element, config);
    }

    function triggerPriceChange(thisEle) {
        const variant = window.hulkapps.product.variants.find((variant) => variant.id == thisEle.value);
        if (variant) {
            window.hulkapps.product.selected_variant_price = variant.price;
            window.hulkapps.product.price = variant.price;
            window.product_price = variant.price;
            updateFormulaPrice(variant.price / 100);
        }
    }

    function updateFormulaPrice(price) {
        $formulaEle.find('[data-name="Quadratmeterpreis"]').val(price);
        $formulaEle.find('[data-name="Unterschied"]').val(price - 1);
        $('.po_changed_formula').first().val('');
        $('.hulk_formula_hidden_prop').val('');
        $('.hulk_formula_hidden_prop').attr('data-price', '');
        $('.po_changed_formula').change();
        window.calc_options_total(window.hulkapps.product.id);
    }

    function showSquareMeterCalc() {
        $('.hulkapps_option.fm_render .hulk-form-field:nth-child(1) input').on('input', function () {
            if ($(this).val() != '') {
                let calculation = (parseFloat($('.hulkapps_option.fm_render .hulk-form-field:nth-child(3) input').val()) * $(this).val()) / 10000;
                if (!isNaN(calculation)) {
                    $('#square-meter-calculation').remove();
                    $('.hulk-custom-calculation-div').append(`<div id="square-meter-calculation"> Quadratmeter pro Stück: <span id="meter-calculation-value">${calculation.toFixed(2).replace('.', ',')}</span> m²`);
                }
            } else {
                $('#square-meter-calculation').remove();
            }
            if (window.hulkapps.product.tags.includes('Sandwichpaneele')) setTimeout(()=>{isSpecialProduct()},500);
        })
    }

    function translateFormulaWarning() {
        const target = document.querySelector('.hulkapps_option.fm_render');
        const config = { childList: true, subtree: true };
        const observer = new MutationObserver(function (mutationsList, observer) {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    for (const addedNode of mutation.addedNodes) {
                        if (addedNode.nodeType === Node.ELEMENT_NODE && addedNode.classList.contains('validation_error')) {
                            const minMax = addedNode.textContent.replace(/[^0-9-]/g, '').split('-');
                            if (minMax && minMax.length == 2) {
                                addedNode.textContent = `Nur Wert zwischen ${minMax[0]} und ${minMax[1]} möglich.`;
                            };
                        }
                    }
                }
            }
        });

        observer.observe(target, config);
    }

    function appendMinMax() {
        const $dataInput = $('.hulkapps_option.fm_render .hulk-form-field:nth-child(1) input');
        const min = $dataInput.attr('min');
        const max = $dataInput.attr('max');
        if (min && max) {
            $dataInput.closest('.hulk-form-field').after(`<div class="hulk-custom-minmax-message">Wert zwischen <span>${min}</span> und <span>${max}</span> cm eingeben</div>`);
        } else if (min && !max) {
            $dataInput.closest('.hulk-form-field').after(`<div class="hulk-custom-minmax-message">Mindestbestellmenge von 100 m² ist erforderlich.</div>`);

        }

    }

    function amendTotalPrice() {
        setInterval(() => {
            const target = document.querySelector('#calculated_option_total');
            if (target.textContent.includes('.')) {
                target.textContent = target.textContent.replace('.', ',');
            }
        }, 50)
    }

    if ($formulaEle.length) {
        triggerPriceChange(document.querySelector('input.product-form__variants[type="hidden"]'));
        showSquareMeterCalc();
        appendMinMax();
        translateFormulaWarning();
        monitorFormulaPrice();
        amendTotalPrice();
        $('.po_changed_formula').attr('step', '0.01');


    }
}

function preventEnter (e){
    if (e.key == 'Enter'){
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
    }
}

function isSpecialProduct(){
    const productQntEle = document.querySelector('input.product-form__input--quantity');
    const productQnt = parseInt(productQntEle.value);
    const singlem2ele = document.querySelector('#meter-calculation-value');
    let singlem2 = 0;
    if (singlem2ele){
        singlem2 = parseFloat(singlem2ele.textContent.replace(',','.'));
    }
    const $addToCartButton = $('button.product-form__cart-submit');
    $('.hulk-custom-total-message, #square-meter-calculation-total').remove();
    $('.hulk-custom-calculation-div').after(`<div id="square-meter-calculation-total"> Quadratmeter insgesamt: ${(productQnt * singlem2).toFixed(2).replace('.', ',')} m²`);
    if ((productQnt * singlem2) < 100 ){
        $('#option_total').after(`<div class="hulk-custom-total-message">Mindestbestellmenge von 100 m² ist erforderlich.</div>`);
        $addToCartButton.addClass('is_hulk_disabled');
        document.addEventListener('keydown',preventEnter);
    } else {
        $addToCartButton.removeClass('is_hulk_disabled');
        document.removeEventListener('keydown',preventEnter);
    }
}


window.addEventListener('load', () => {
    const hook = setInterval(() => {
        const hulkDiv = document.querySelector('[id^="hulkapps_custom_options_"]');
        if (hulkDiv && hulkDiv.children.length) {
            clearInterval(hook);
            hulkapps_custom_init();
            if (window.hulkapps.product.tags.includes('Sandwichpaneele')){
                document.querySelector('input.product-form__input--quantity').addEventListener('change',isSpecialProduct);
                document.querySelector('.product-page-qty').addEventListener('click',()=>{setTimeout(()=>{isSpecialProduct()},10)});
            }
        }
    },10);
    setTimeout(()=>{
      clearInterval(hook);
    },15000)
})